var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',[_c('feather-icon',{attrs:{"badge":_vm.unread,"badge-classes":"bg-danger","size":"21","icon":"SendIcon"},on:{"click":function($event){return _vm.$router.push({name: 'misc-bulletins'})}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }